(function () {
  angular.module("akitabox.desktop.building.admin", [
    "ui.router",
    "akitabox.constants",
    "akitabox.core.router",
    "akitabox.desktop.admin.job",
    "akitabox.desktop.building.admin.job",
  ]);
})();
